import { onUnmounted, ref } from 'vue'

export function useEmailVerificationPoll(fetchStatus, onVerified) {
  const isPolling = ref(false)
  let timer = null

  const stop = () => {
    if (timer) {
      clearInterval(timer)
      timer = null
    }
    isPolling.value = false
  }

  const start = () => {
    stop()
    isPolling.value = true

    timer = setInterval(async () => {
      try {
        const { data } = await fetchStatus()
        if (data.verified) {
          stop()
          onVerified()
        }
      } catch {
        // polling
      }
    }, 5000)
  }

  onUnmounted(stop)

  return { isPolling, start, stop }
}
